"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9256],{

/***/ 9256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _yema_designkit_webkit_layouts_Section__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46350);




var CMS_Body = function(param) {
    var content = param.content;
    var createMarkup = function() {
        if (!content || content === "") return "";
        var parsedContent = content;
        parsedContent = parsedContent.replace(/<iframe\s*(.*)>\s*(.*)<\/iframe>/g, '<div class="relative pb-[56.25%] h-0 shadow-down overflow-hidden"><iframe class="absolute top-0 left-0 w-full h-full" $1>$2</iframe></div>');
        return {
            __html: parsedContent
        };
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_yema_designkit_webkit_layouts_Section__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: "body_content",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "container-fluid",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "rich-text",
                    dangerouslySetInnerHTML: createMarkup()
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flow-root"
                })
            ]
        })
    });
};
CMS_Body.defaultProps = {};
CMS_Body.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (CMS_Body);


/***/ })

}]);